export default "__VITE_ASSET__73a4a5ac__"